import ExpiringSoonMessage from "./ExpiringSoonMessage";
import ExpiredMessage from "./ExpiredMessage";
import styles from "./ExpirationMessage.module.scss";
import { License } from "../../api/decimal/common-types/manageAssets.ts";
import { useExploreBookAvailable } from "../../../routes/home/common/explore/useExploreBookAvailable.ts";

export default function ExpirationMessage({
  license,
  explore,
}: {
  license: License;
  explore?: VST.Bridge.Asset;
}) {
  const exploreAvailable = useExploreBookAvailable(explore);
  if (exploreAvailable) {
    // expiring / expiring soon is not a thing in explore if borrow/open is available
    return null;
  }
  return !license.expired ? (
    <ExpiringSoonMessage
      license={license}
      className={styles.expirationMessage}
    />
  ) : (
    <ExpiredMessage license={license} className={styles.expirationMessage} />
  );
}
